
import { ProfileTranslationType } from "../../features/profile.types";

export const profile: ProfileTranslationType = {
  profile: {
    title: "个人资料",
    dangerZone: "危险区域",
    deleteAccount: "删除账户",
    confirmDelete: "确认删除",
    deleteWarning: "您确定要删除您的账户吗？此操作无法撤销。",
    confirmDeleteButton: "删除账户",
    accountDeleted: "账户已删除",
    accountDeletedMessage: "您的账户已成功删除。"
  },
  common: {
    cancel: "取消",
    delete: "删除",
    deleteConfirmation: "确认删除",
    deleteConfirmationMessage: "您确定要删除"
  }
};
